import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';


/**
 * APIL Url: ADAC.Internet.Core.Models.WebApi.Mitgliedschaft.DsgvoAuskunftRequest
 * Klasse für DsgvoAuskunftsersuchen
 * Endpoints: /api/MeineDaten/dsgvoauskunft
 */
export class DsgvoAuskunftRequestApi extends BaseApiModel {
	constructor(initialProperties?: Partial<DsgvoAuskunftRequestApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected processId: number;
	/**
	 * Description: Vorgangsnummer
	 * APIL Type: int64
	 */
	get ProcessId(): number {
		return this.processId;
	}

	/**
	 * Description: Vorgangsnummer
	 * APIL Type: int64
	 */
	set ProcessId(value: number) {
		this.processId = value;
	}

	protected htmlFragment: string;
	/**
	 * Description: Html Fragment zur PDF-Generierung für KIM-Prozess
	 * APIL Type: string
	 */
	get HtmlFragment(): string {
		return this.htmlFragment;
	}

	/**
	 * Description: Html Fragment zur PDF-Generierung für KIM-Prozess
	 * APIL Type: string
	 */
	set HtmlFragment(value: string) {
		this.htmlFragment = value;
	}

	protected email: string;
	/**
	 * Description: E-Mail
	 * APIL Type: string
	 */
	get Email(): string {
		return this.email;
	}

	/**
	 * Description: E-Mail
	 * APIL Type: string
	 */
	set Email(value: string) {
		this.email = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): DsgvoAuskunftRequestApi {
		return AppUtils.Helper.createFromMap(dataObject, DsgvoAuskunftRequestApi, (key, value) => {
			switch (key.toLowerCase()) {

				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.ProcessId = this.processId;
		result.HtmlFragment = this.htmlFragment;
		result.Email = this.email;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}